import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedProfileApi = profileApi.injectEndpoints({
    endpoints: (builder) => ({
        editProfile: builder.mutation({
            query: (editProfileConfig) => ({
                url: '/profile/edit',
                method: 'POST',
                body: editProfileConfig,
            }),
        }),
        profileImageUpload: builder.mutation({
            query: (imageUploadConfig) => ({
                url: '/users/profile/image/change',
                method: 'POST',
                body: imageUploadConfig,
            }),
        }),
        profilePasswordChange: builder.mutation({
            query: (passwordChangeConfig) => ({
                url: '/profile/password/change',
                method: 'POST',
                body: passwordChangeConfig,
            }),
        }),
        userDelete: builder.mutation({
            query: (config) => ({
                url: '/user/delete',
                method: 'POST',
                body: config,
            }),
        }),
    }),
    overrideExisting: false,
});
export const {
    useProfileImageUploadMutation,
    useProfilePasswordChangeMutation,
    useEditProfileMutation,
    useUserDeleteMutation,
} = injectedProfileApi;
export default profileApi;
